import React, { useState, useEffect, useContext } from 'react';
import NextLink from 'next/link';
import useSWR from 'swr';
import {
	Box, Skeleton, Link as ChakraLink, Text, Tooltip, Icon, Heading,
} from '@chakra-ui/react';
import { FontAwesomeIcon as Fa } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { ContextStore } from '../../contexts/authContext';
import { USER_GROUP } from '../../utils/constants';

export default function Container({
	width, height, link, shortName, children, innerRef, menu, bigTitle = false,
}) {
	const { userState } = useContext(ContextStore);
	const [name, setName] = useState('');
	const [description, setDescription] = useState('');
	const { data: graphMeta } = useSWR(`/api/v1/graphs/${shortName}`);

	useEffect(() => {
		if (graphMeta) {
			if (graphMeta.name) {
				setName(graphMeta.name);
			}
			if (graphMeta.description) {
				setDescription(graphMeta.description);
			}
		}
	}, [graphMeta]);

	return (
		<>
			<Box
				shadow="md"
				borderRadius={10}
				w={width}
				h={`calc(${height} + 50px)`}
				minH="200px"
				bgColor="rgba(200, 200, 200, 0.1)"
				position="relative"
				ref={innerRef}
			>
				{!bigTitle ? (
					name ? (
						<Box>
							<ChakraLink as={NextLink} href={link ? `/graph/${link}` : `#${shortName}`} textDecoration="none">
								<Text d="inline-block" mt={4} ml={3} fontWeight={600} color="title">{name}</Text>
							</ChakraLink>
							{description ? (
								<Tooltip label={description}>
									<Box d="inline-block" ml={2}>
										<Icon as={Fa} icon={faInfoCircle} />
									</Box>
								</Tooltip>
							) : null}
						</Box>
					) : (
						<Skeleton h="20px" w="min(50%, 250px)" opacity={0.5} />
					)
				) : (
					name ? (
						<Box py={12}>
							<Heading as="h2" fontSize="2xl" textAlign="center">{name}</Heading>
							<ChakraLink
								name={shortName}
								display="block"
								position="relative"
								top="-200px"
								visibility="hidden"
							>
								{shortName}
							</ChakraLink>
							{description ? (
								<Text fontSize="md" textAlign="center">
									{description}
								</Text>
							) : null}
						</Box>
					) : (
						<Skeleton h="25px" w="min(50%, 250px)" opacity={0.5} />
						)
					)}
				<Box position="absolute" top={0} right={0} pr={2} pt={3}>
					{menu || null}
				</Box>
				{children}
			</Box>
			{userState?.group >= USER_GROUP.ADMIN ? (
				<Box float="right" fontSize="xs" color="gray">
					(
					{shortName}
					)
				</Box>
			) : null}
		</>
	);
}
